<template>
  <KDialog
    :loading="loading"
    :title="title"
    :visible="visible"
    showClose
    :actions="actions"
    @click:add="save"
    @click:edit="save"
    @click:close="close"
  >
    <k-form ref="form">
      <v-row class="ma-0">
        <!-- Nome da Configuração -->
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            :rules="[$validation.isRequired]"
            label="Dia"
            :error-messages="errors.day"
            v-model="data.day"
            persistent-hint
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </k-form>
  </KDialog>
</template>

<script>
import KDialog from "@/components/KDialog";
import KForm from "@/components/KForm";

export default {
  components: {
    KDialog,
    KForm
  },

  data() {
    return {
      // Define se está visível
      visible: false,
      // Armazena os dados que virão via função para preencher
      data: {},

      isEditing: false,
      title: null,

      loading: false,

      //
      errors: {
        name: null,
        slug: null,
        icon: null
      }
    };
  },

  computed: {
    actions() {
      if (this.isEditing) {
        return [
          {
            eventName: "click:edit",
            label: "Salvar Alterações"
          }
        ];
      }

      return [{ eventName: "click:add", label: "Cadastrar" }];
    }
  },

  methods: {
    /*******************************************************
     *
     *  FUNÇÕES PARA SALVAR E EDITAR OS DADOS NO STORE
     *
     *******************************************************/

    /**
     * Salva os dados no Store
     */
    async save() {
      try {
        //
        this.errors = {};
        // Se as demais validações passaram
        if (this.$refs["form"].validate()) {
          this.loading = true;
          //
          await this.$store.dispatch("expiration_dates/save", {
            payload: this.data,
            editing: this.isEditing
          });

          this.loading = false;
          this.$message.success("Registro salvo com sucesso");
          this.close();
        } else {
          this.$message.error("Verifique os campos marcados em vermelho");

          this.loading = false;
        }
      } catch (error) {
        this.errors = this.$message.serverError(error);
        this.loading = false;
      }
    },

    /*******************************************************
     *
     *  FUNÇÕES BÁSICAS DE QUALQUER DIALOG
     *
     *******************************************************/

    /**
     * Abre o dialog preparado para cadastrar um novo dado
     */
    openToAdd() {
      // Altera o título
      this.title = "Nova Data";

      // Limpa os dados
      this.clear();

      // Define se é uma edição
      this.isEditing = false;

      // Abre por último, depois que está tudo preenchido
      this.open();
    },

    /**
     * Abre o dialog preparado para alteerar os dados
     */
    openToEdit({ id, day }) {
      // Altera o título
      this.title = `Editar o dia "${day}"`;

      // Mescla os dados recebidos para não alterar o que está para trás
      this.data = {
        id,
        day
      };

      // Define se é uma edição
      this.isEditing = true;

      // Abre por último, depois que está tudo preenchido
      this.open();
    },

    /**
     * Abre o dialog
     */
    open() {
      this.visible = true;
    },

    /**
     * Fecha o dialog
     */
    close() {
      this.$refs.form.resetValidation();
      this.visible = false;
      this.clear();
    },

    /**
     * Limpa os dados do dialog
     */
    clear() {
      this.data = {};
    }
  }
};
</script>

<style>
</style>
